export const ownerWeekCopy = { lugar: "Semana" } as const;
